export const initializeJsonTable = (value: unknown): string | undefined => {
  if (!value) {
    return undefined
  }

  if (typeof value === 'string') {
    return value.trim() ? value : undefined
  }

  return JSON.stringify(value)
}

export const prepareJsonTable = (formValue: unknown): unknown | null => {
  if (!formValue) {
    return null
  }

  if (typeof formValue !== 'string') {
    return formValue
  }

  const trimmed = formValue.trim()

  if (!trimmed) {
    return null
  }

  try {
    const parsed = JSON.parse(trimmed)

    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && Object.keys(parsed).length === 0) {
      return null
    }

    return parsed
  } catch {
    return null
  }
}
